module.exports = __webpack_public_path__ + "static/img/cd21310.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/xczx/img/bg.png
// module id = 652
// module chunks = 2